import { useEffect } from "react";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { resolveSelectedSubagentRunId, subagentRunSelectionToCommit } from "@/lib/subagent-tasks";
import { useChatStore } from "@/stores/useChatStore";
import { SubagentTaskDetail } from "./SubagentTaskDetail";
import { SubagentTaskList } from "./SubagentTaskList";

export function SubagentTasksPane() {
	const chatId = useChatStore((state) => state.chatId);
	const runs = useChatStore((state) => state.subagentRuns) ?? [];
	const workflowRuns = useChatStore((state) => state.workflowRuns);
	const selectedId = useChatStore((state) => state.selectedSubagentRunId);
	const selectSubagentRun = useChatStore((state) => state.selectSubagentRun);
	const shownId = resolveSelectedSubagentRunId(runs, selectedId);
	// 一覧に行が無い run id でも詳細は開ける (run は任意)。一覧取得を待たずに実行履歴へ入れる。
	const shown = runs.find((run) => run.id === shownId);
	// 導出した表示対象を選択として store に確定させる (判定は subagentRunSelectionToCommit)。
	const idToCommit = subagentRunSelectionToCommit(runs, selectedId);
	useEffect(() => {
		if (idToCommit !== null) selectSubagentRun(idToCommit);
	}, [idToCommit, selectSubagentRun]);
	// workflow はノードを起動時に宣言する。run がまだ 1 件も無くても、これから走るノードの
	// 輪郭は描けるので、workflow 行があるうちは空表示にしない。
	if (shownId === null && workflowRuns.length === 0)
		return (
			<p
				data-testid="subagent-tasks-pane"
				className="m-0 flex h-full items-center justify-center p-4 text-caption text-fg-3"
			>
				タスクはまだありません
			</p>
		);
	return (
		<div data-testid="subagent-tasks-pane" className="h-full min-h-0">
			<PanelGroup direction="horizontal">
				{/* workflow カードは名前・モデル・トークン・時間を横に並べる。30% だと名前の列が潰れる。 */}
				<Panel defaultSize={45} minSize={20}>
					{/* セクションの開閉はユーザー操作を覚えるので、チャットが変わったら作り直す。 */}
					<SubagentTaskList
						key={chatId}
						runs={runs}
						workflowRuns={workflowRuns}
						selectedId={shownId}
						onSelect={selectSubagentRun}
					/>
				</Panel>
				<PanelResizeHandle className="izanagi-resize-handle" />
				<Panel defaultSize={55} minSize={30}>
					{shownId === null ? (
						<p className="m-0 flex h-full items-center justify-center p-4 text-caption text-fg-3">
							実行が始まると、ここに履歴が表示されます
						</p>
					) : (
						<SubagentTaskDetail key={shownId} runId={shownId} run={shown} />
					)}
				</Panel>
			</PanelGroup>
		</div>
	);
}
